import {
  hasCompleteSearchPrefixMatch,
  isSearchQueryEligible,
  normalizeSearchQuery,
  tokenizeSearchText,
} from './searchUtils.js'

const createTickerResult = (document, tickerEntry) => {
  const derivedData = document?.document?.derivedStructData || {}
  const structuredData = document?.document?.structData || {}
  return {
    ...document,
    id: tickerEntry.id,
    document: {
      ...document.document,
      derivedStructData: {
        ...derivedData,
        link: tickerEntry.path,
        title: tickerEntry.title,
      },
      structData: {
        ...structuredData,
        ticker: tickerEntry.ticker,
      },
    },
  }
}

export const getSearchIndexDocumentIds = (searchTerms, prefixes = {}) => {
  const query = normalizeSearchQuery(searchTerms)
  if (!isSearchQueryEligible(query)) return []

  const queryTokens = Array.from(new Set(tokenizeSearchText(query)))
  if (!queryTokens.length) return []

  const firstPosting = prefixes[queryTokens[0]]
  if (!Array.isArray(firstPosting)) return []

  let matchingIds = new Set(firstPosting)
  queryTokens.slice(1).forEach((token) => {
    const posting = new Set(
      Array.isArray(prefixes[token]) ? prefixes[token] : []
    )
    matchingIds = new Set(
      Array.from(matchingIds).filter((documentId) => posting.has(documentId))
    )
  })

  return Array.from(matchingIds).sort((first, second) => first - second)
}

export const getProductSearchResults = (searchTerms, productIndex = {}) => {
  const query = normalizeSearchQuery(searchTerms)
  if (!isSearchQueryEligible(query)) return []

  const documents = Array.isArray(productIndex.documents)
    ? productIndex.documents
    : []
  const matchingDocumentIds = new Set(
    getSearchIndexDocumentIds(query, productIndex.prefixes)
  )
  const exactTickerEntries = Array.isArray(
    productIndex.exactTickers?.[query.toLowerCase()]
  )
    ? productIndex.exactTickers[query.toLowerCase()]
    : []
  const exactTickersByDocument = new Map()

  exactTickerEntries.forEach((entry) => {
    const entries = exactTickersByDocument.get(entry.documentIndex) || []
    entries.push(entry)
    exactTickersByDocument.set(entry.documentIndex, entries)
    matchingDocumentIds.add(entry.documentIndex)
  })

  return Array.from(matchingDocumentIds)
    .sort((first, second) => first - second)
    .flatMap((documentIndex) => {
      const document = documents[documentIndex]
      if (!document) return []

      const tickerEntries = exactTickersByDocument.get(documentIndex)
      if (tickerEntries?.length) {
        return tickerEntries
          .filter((entry) => entry.path)
          .map((entry) => createTickerResult(document, entry))
      }

      return hasCompleteSearchPrefixMatch(document, query) ? [document] : []
    })
}
